import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    cancel: string;
    continue: string;
    error: string;
    keepRestriction: string;
    removeRestriction: string;
    restrictingDetails: string;
    restrictingTitle: string;
    unrestrictingDetails: string;
    unrestrictingTitle: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            cancel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useRestrictFolder.cancel?c=2ojhd8rzicmo0", defaultMessage: "Cancel" }));
                },
                enumerable: true,
                configurable: true
            },
            continue: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useRestrictFolder.continue?c=rh3djn0viyad", defaultMessage: "Make Restricted" }));
                },
                enumerable: true,
                configurable: true
            },
            error: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useRestrictFolder.error?c=3hysb3djkf1u6", defaultMessage: "Something went wrong" }));
                },
                enumerable: true,
                configurable: true
            },
            keepRestriction: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useRestrictFolder.keepRestriction?c=35mcch4f5dcn8", defaultMessage: "Keep Restriction" }));
                },
                enumerable: true,
                configurable: true
            },
            removeRestriction: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useRestrictFolder.removeRestriction?c=e4zb5ju0igx2", defaultMessage: "Remove Restriction" }));
                },
                enumerable: true,
                configurable: true
            },
            restrictingDetails: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useRestrictFolder.restrictingDetails?c=xoxj6qt3vuzf", defaultMessage: "Only people directly invited will have access, plus admins. Any assets from this folder that have been added to Shares will be removed." }));
                },
                enumerable: true,
                configurable: true
            },
            restrictingTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useRestrictFolder.restrictingTitle?c=2b3olxv48y9eg", defaultMessage: "Are you sure you want to make this folder restricted?" }));
                },
                enumerable: true,
                configurable: true
            },
            unrestrictingDetails: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useRestrictFolder.unrestrictingDetails?c=32rsjv6w32hic", defaultMessage: "All project members will now have access. The folder and its assets can be visible in Shares." }));
                },
                enumerable: true,
                configurable: true
            },
            unrestrictingTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useRestrictFolder.unrestrictingTitle?c=16lcv1y1puuf4", defaultMessage: "Are you sure you want to remove restriction from this folder?" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
